var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","line-height":"500px","font-size":"20px"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),(_vm.type.includes('mobile'))?_c('div',{staticClass:"mobile"},[_c('img',{attrs:{"src":require("../../../static/m_code.png"),"alt":"","srcset":undefined + " undefined"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ac88bcf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/null.vue
// module id = null
// module chunks = 